<template>
    <div class="modal-card prd-modal-card">
        <header class="modal-card-head">
            <div>
                <p class="modal-card-title">Analisar item</p>
                <p class="is-size-7 has-text-grey">{{ model.descricao }}</p>
            </div>
        </header>
        <section class="modal-card-body">
            <b-field label="Produção">
                <b-select v-model="model.statusProducao" expanded>
                    <option :value="1">Aguardando análise</option>
                    <option :value="2">Podemos produzir</option>
                    <option :value="3">Não produzimos</option>
                    <option :value="4">Pendente de informação</option>
                </b-select>
            </b-field>
            <div v-if="model.statusProducao === 2" class="columns">
                <div class="column">
                    <b-field label="Valor unitário comercial">
                        <b-numberinput v-model="model.valorUnitarioComercial" :min="0" :step="0.01" controls-position="compact" />
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Prazo (dias)">
                        <b-numberinput v-model="model.prazoProducaoDias" :min="0" :step="1" controls-position="compact" />
                    </b-field>
                </div>
            </div>
            <b-field v-if="model.statusProducao === 3" label="Motivo">
                <b-select v-model="model.motivoNaoProduzido" expanded>
                    <option :value="null">Selecione</option>
                    <option v-for="motivo in motivos" :key="motivo.id" :value="motivo.id">{{ motivo.nome }}</option>
                </b-select>
            </b-field>
            <b-field v-if="model.statusProducao === 3" label="Detalhes do motivo">
                <b-input v-model.trim="model.motivoNaoProduzidoObservacao" maxlength="1000" />
            </b-field>
            <b-field label="Observações e pendências">
                <b-input v-model.trim="model.observacoesProducao" type="textarea" rows="4" maxlength="2000" />
            </b-field>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
            <b-button @click="$emit('close')">Cancelar</b-button>
            <b-button type="is-primary" icon-left="check" @click="$emit('salvar', model)">Salvar análise</b-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'PrdAnaliseItemModal',
    props: { item: { type: Object, required: true } },
    data() {
        return {
            model: JSON.parse(JSON.stringify(this.item)),
            motivos: [
                { id: 1, nome: 'Não temos máquina' },
                { id: 2, nome: 'Não temos ferramenta' },
                { id: 3, nome: 'Material não trabalhado' },
                { id: 4, nome: 'Prazo inviável' },
                { id: 5, nome: 'Especificação inviável' },
                { id: 6, nome: 'Outro' },
            ],
        }
    },
}
</script>

<style scoped>
.prd-modal-card {
    width: min(640px, calc(100vw - 2rem));
}
</style>
